import React, {Component, Fragment} from 'react';
import axios from 'axios';
import {RESOURCES as reportsResources} from '../fuseJobsResourceMap';
import {getGetHeaders} from '../shared/serverFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import {tableStyles} from "../shared/styles-table";
import CircularProgress from 'material-ui/CircularProgress';

/**
 * Report Jobs class for retrieving all Job Configurations
 *
 */
export class ReportJobsConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            message: ''
        };

        this.fetchConfig = this.fetchConfig.bind(this);
        this.processConfigData = this.processConfigData.bind(this);
    }

    componentDidMount() {
        this.fetchConfig();
    }

    fetchConfig() {
        this.setState({
            loading: true,
            message: 'Loading Job Configurations'
        });

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        let resource = reportsResources.ReportJobConfig.GET_ONE();
        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data && result.data.payload) {
                this.processConfigData(result.data.payload);
            } else {
                this.processConfigData(null);
            }
        }).catch((error) => {
            this.processConfigData(null);
        });
    }

    processConfigData = (data) => {
        const message = (!data || data.error) ? 'Sorry, the Jobs Configuration could not be loaded.' : '';
        this.setState({
            loading: false,
            message: message
        }, () => {
            if (typeof this.props.onConfig === 'function') {
                this.props.onConfig(data);
            }
        });
    };

    render() {
        const {
            loading,
            message
        } = this.state;

        return (
            <Fragment>
                <div className="job-config-loader">
                    {loading &&
                        <CircularProgress
                            className="app-loader"
                            size={20}
                            thickness={2}
                            style={tableStyles.tableIconLoader}
                        />
                    }
                    {message !== '' &&
                        <span className="config-message">{message}</span>
                    }
                </div>
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/components/ReportJobsConfig.js